module.exports = __webpack_public_path__ + "img/trainingTmp.dd5addce.png";